import { useMutation } from "@apollo/client";
import { useCallback } from "react";

import FlashContext from "components/FlashMessages/FlashContext";
import useTypedContext from "hooks/useTypedContext";
import {
  GithubEnterpriseIntegration,
  MutationGithubEnterpriseIntegrationUpdateArgs,
} from "types/generated";
import useAnalytics from "hooks/useAnalytics";
import { AnalyticsPageVCS } from "hooks/useAnalytics/pages/vcs";

import { UPDATE_GITHUB_ENTERPRISE_INTEGRATION } from "./gql";

const useUpdateGitHubEnterpriseIntegration = () => {
  const { onError, reportSuccess } = useTypedContext(FlashContext);

  const trackSegmentAnalyticsEvent = useAnalytics({
    page: AnalyticsPageVCS.VCSIntegrations,
  });

  const [githubEnterpriseIntegrationUpdate, { loading }] = useMutation<{
    githubEnterpriseIntegrationUpdate: GithubEnterpriseIntegration;
  }>(UPDATE_GITHUB_ENTERPRISE_INTEGRATION, {
    refetchQueries: ["SearchVCSIntegrations"],
  });

  const updateGitHubEnterpriseIntegration = useCallback(
    (input: MutationGithubEnterpriseIntegrationUpdateArgs, successCallback?: () => void) => {
      githubEnterpriseIntegrationUpdate({
        variables: input,
      })
        .then(({ data }) => {
          if (data?.githubEnterpriseIntegrationUpdate) {
            reportSuccess({
              message: `Integration ${data.githubEnterpriseIntegrationUpdate.name} was successfully updated`,
            });
            successCallback?.();

            trackSegmentAnalyticsEvent("Integration Edit - Finish", {
              integration: "GitHub Enterprise",
            });
          }
        })
        .catch(onError);
    },
    [githubEnterpriseIntegrationUpdate, onError, reportSuccess, trackSegmentAnalyticsEvent]
  );

  return {
    updateGitHubEnterpriseIntegration,
    loading,
  };
};

export default useUpdateGitHubEnterpriseIntegration;
